// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"2bc2c636","49":"44355f24","203":"f9a54bea","278":"fea75ce3","318":"0ffbf0b2","347":"f6bc71de","447":"4993f4f9","547":"d5e1731f","579":"8eb73115","734":"649829b9","810":"2b1bf932","939":"a5b4d880"}[chunkId] + ".chunk.js";
};